var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('line-chart',{attrs:{"chart-data":_vm.chartData,"tooltip-coloring-rule":_vm.tooltipColoringCallback,"scale-x-text":_vm.scaleXText,"scale-y-text":_vm.scaleYText}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }